/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { cn } from "tailwind-variants";
import { isTouchDevice } from "common/utils/browser";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import UseSvg from "common/vue/components/UseSvg.react.vue";
// eslint-disable-next-line import/no-cycle
import ArtworkImage from "./ArtworkImage.vue";
import BackgroundToggle from "./common/BackgroundToggle.vue";
import MobileImageModal from "./common/MobileImageModal.vue";
import { useDtfStore } from "./store";
import { getArtworkSrc } from "./utils";
import "./ArtworkFullScreen.scss";

export default function ArtworkFullScreen({
  artwork = {},
  activeConfigSection,
  withMade = false,
  shouldDisableSlider = false,
  sliderBeforeImage = ""
}) {
  const store = useDtfStore();
  const [showComparisonModal, setShowComparisonModal] = useState(false);

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  function enabledButton() {
    return isStandardArtwork() && !artwork?.isLoading && artwork?.url;
  }

  function showFullScreenButton() {
    return (enabledButton() || withMade) && isTouchDevice();
  }

  function showDesktopModal() {
    return isStandardArtwork() && showComparisonModal && artwork && !isTouchDevice();
  }

  function showMobileModal() {
    return showComparisonModal && artwork && isTouchDevice();
  }

  function wrapperClass() {
    return `js-modal-magnify-wrapper-${artwork?.id || "x"}`;
  }

  function artworkSrc() {
    return getArtworkSrc(artwork);
  }

  function toggleComparisonModal() {
    setShowComparisonModal(!showComparisonModal);
  }

  return (
    <>
      {showFullScreenButton() ? (
        <button
          className={cn("artwork-full-screen__button scope-ef81b391", {
            "artwork-full-screen__button--with-made": withMade
          })}
          disabled={!enabledButton()}
          type="button"
          onClick={toggleComparisonModal}
          data-testid="artwork-full-screen-button"
        >
          <UseSvg
            className="artwork-full-screen__button-icon scope-ef81b391"
            icon="full-screen"
            data-testid="artwork-full-screen-button-icon"
          />

          <span className="scope-ef81b391">Full Screen</span>
        </button>
      ) : null}
      {showDesktopModal() ? (
        <CommonModal
          className="scope-ef81b391"
          onClose={toggleComparisonModal}
          data-testid="common-modal"
        >
          <BackgroundToggle
            className="scope-ef81b391"
            modelValue={store.backgroundType}
            onUpdateModelValue={e => {
              store.setBackgroundType(e);
            }}
            data-testid="background-toggle"
          />

          <div className="artwork-full-screen__artwork-image scope-ef81b391">
            <ArtworkImage
              className="scope-ef81b391"
              key={artwork.id}
              artwork={artwork}
              fitToContainer={true}
              activeConfigSection={activeConfigSection}
              data-testid="artwork-image"
            />
          </div>
        </CommonModal>
      ) : null}
      {showMobileModal() ? (
        <MobileImageModal
          className="scope-ef81b391"
          src={shouldDisableSlider ? sliderBeforeImage : artworkSrc()}
          wrapperClass={wrapperClass()}
          onClose={toggleComparisonModal}
          data-testid="mobile-image-modal"
        />
      ) : null}
    </>
  );
}
